import { getPaymentAccounts } from "@/apiv2/accounting";
import { createApiV2 } from "@/apiv2/common";
import { createAction, createSetterActions } from "@/redux/helpers/action";
import { STATUS } from "@/utils/constants";

import { MODULE } from "./constants";

export const [
  setConnectionStatus,
  setFetchConnectionStatusStatus,
  setPaymentAccounts,
  setFetchPaymentAccountsStatus,
  setConnectStripeStatus,
  setAvailable,
] = createSetterActions(MODULE, [
  "connectionStatus",
  "fetchConnectionStatusStatus",
  "paymentAccounts",
  "fetchPaymentAccountsStatus",
  "connectStripeStatus",
  "available",
]);

export const reset = createAction(`${MODULE}/RESET`);

export const fetchStripeConnectionStatus = () => async (dispatch) => {
  try {
    dispatch(setFetchConnectionStatusStatus(STATUS.PENDING));
    const response = await createApiV2("GET", "payments/stripe/connect/status/")();
    dispatch(setConnectionStatus(response.data?.connection ?? null));
    dispatch(setAvailable(response.data?.available ?? false));
    dispatch(setFetchConnectionStatusStatus(STATUS.FULFILLED));
  } catch {
    dispatch(setConnectionStatus(null));
    dispatch(setAvailable(false));
    dispatch(setFetchConnectionStatusStatus(STATUS.REJECTED));
  }
};

export const fetchPaymentAccounts = () => async (dispatch) => {
  try {
    dispatch(setFetchPaymentAccountsStatus(STATUS.PENDING));
    const response = await getPaymentAccounts()();
    dispatch(setPaymentAccounts(Array.isArray(response.data) ? response.data : []));
    dispatch(setFetchPaymentAccountsStatus(STATUS.FULFILLED));
  } catch {
    dispatch(setPaymentAccounts([]));
    dispatch(setFetchPaymentAccountsStatus(STATUS.REJECTED));
  }
};

export const initiateStripeConnect = () => async (dispatch) => {
  try {
    dispatch(setConnectStripeStatus(STATUS.PENDING));
    const response = await createApiV2("POST", "payments/stripe/connect/")();
    dispatch(setConnectStripeStatus(STATUS.FULFILLED));
    return response.data.url;
  } catch {
    dispatch(setConnectStripeStatus(STATUS.REJECTED));
    return null;
  }
};
